import { config } from '@/config';
import { Operation, ServerError, ServerParseError } from '@apollo/client';
import * as Sentry from '@sentry/vue';
import { GraphQLFormattedError } from 'graphql';

export function logErrorMessage(message: string) {
    if (config.debug) {
        console.error(message);
    }
    if (config.sentryDsn) {
        Sentry.captureMessage(message);
    }
}

export function logGraphQLError(error: GraphQLFormattedError, operation: Operation) {
    if (config.debug) {
        const errorMessage = `[GraphQL error]: ${error.message}, operation: ${operation.operationName}`;
        console.error(errorMessage);
    }
    if (config.sentryDsn) {
        Sentry.captureException(error, {
            tags: {
                kind: 'GraphQL',
                operationName: operation.operationName,
            },
            extra: {
                message: error.message,
                path: error.path,
                extensions: error.extensions,
                query: operation.query?.loc?.source?.body,
                variables: operation.variables,
            },
        });
    }
}

export function logNetworkError(error: Error | ServerError | ServerParseError, operation: Operation) {
    if (config.debug) {
        const errorMessage = `[Network error]: ${error.message}, operation: ${operation.operationName}`;
        console.error(errorMessage);
    }
    if (config.sentryDsn) {
        Sentry.captureException(error, {
            tags: {
                kind: 'NetworkError',
                operationName: operation.operationName,
            },
            extra: {
                message: error.message,
                query: operation.query?.loc?.source?.body,
                variables: operation.variables,
            },
        });
    }
}
